import { InfoStateTokens, InfoTypeTokens, } from '@voltmoney/schema';
export const args = {
    label: 'Pay as you go',
    message: 'Just pay minimum interest amount every 30 days. The principal can be repaid at the end of the credit limit tenure. There is no fixed emi payment every month, plan the repayments according to your convenience.',
    actionText: 'Verify',
    type: InfoTypeTokens.SUCCESS,
    state: InfoStateTokens.GRADIENT,
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(InfoTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    state: {
        control: 'select',
        options: [
            ...Object.values(InfoStateTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
